import * as R from 'ramda';

const isBlank = R.either(R.isNil, R.isEmpty);
export default ({min, max, legend}) => {
	let text = '';
	if (isBlank(min) && isBlank(max)) {
		text = legend;
	} else {
		if (!isBlank(min) && isBlank(max)) {
			text = `min ${min}`;
		} else if (isBlank(min) && !isBlank(max)) {
			text = `max ${max}`;
		} else {
			text = `${min} - ${max}`;
		}
	}
	return text;
};
